var _a;
import { __decorate, __metadata, __param } from "tslib";
import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash';
import { inject, injectable } from '@/inversify.config';
import { EnvConfig } from '@/domains/base/types/env-config.interface';
let SpaceApiImpl = class SpaceApiImpl {
    constructor(_envConfig) {
        this._envConfig = _envConfig;
    }
    getSpaceInitApi(spaceId) {
        return psHttp({
            url: `${this._envConfig.workspaceApiUrlPrefix}/permission/space/${spaceId}`,
            method: 'GET',
            transformCode: true,
        }).then(({ data }) => {
            return _.get(data, 'data', {});
        });
    }
    async updateSpaceAccessTimeApi(spaceId) {
        await psHttp({
            url: `${this._envConfig.workspaceApiUrlPrefix}/space/${spaceId}/access`,
            method: 'POST',
            transformCode: true,
        });
    }
};
SpaceApiImpl = __decorate([
    injectable(),
    __param(0, inject(EnvConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof EnvConfig !== "undefined" && EnvConfig) === "function" ? _a : Object])
], SpaceApiImpl);
export { SpaceApiImpl };
